import React from "react";
import ScannerDevice from "./ScannerDevice";
import ManualInput from "./ManualInput";
import { Tabs, Tab } from "react-bootstrap";

const BarcodeScanner = ({ id, endpoint }) => {
  return (
    <div className="col-xs-12">
      <div className="card">
        <div className="card-body">
          <Tabs defaultActiveKey="scannerDevice" id="uncontrolled-tab-example">
            <Tab eventKey="scannerDevice" title="Barcode Scanner">
              <ScannerDevice id={id} endpoint={endpoint} />
            </Tab>
            <Tab eventKey="manualInput" title="Manual Input">
              <ManualInput id={id} endpoint={endpoint} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default BarcodeScanner;
